module.exports = __webpack_public_path__ + "img/logo-light.62cb43ee.png";